import { __read } from 'tslib';
import { useRef } from 'react';
import { useBoolean } from '../../hooks/useBoolean/index.js';
import { useLayoutSidebarCollapseState } from './useLayoutSidebarCollapseState.js';

var closeOnClick = function (setIsOpen) {
    return function (event) {
        var target = event.target;
        if (!event.isDefaultPrevented() &&
            ["A", "BUTTON"].includes(target.nodeName)) {
            setIsOpen(false);
        }
    };
};
var useLayoutSidebar = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.defaultIsOpen, defaultIsOpen = _c === void 0 ? false : _c;
    var ref = useRef(null);
    var _d = __read(useBoolean({
        defaultValue: defaultIsOpen,
    }), 3), isOpen = _d[0], setIsOpen = _d[1], toggleIsOpen = _d[2];
    var collapseState = useLayoutSidebarCollapseState();
    return {
        collapseState: collapseState,
        ref: ref,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        toggleIsOpen: toggleIsOpen,
        props: {
            "data-is-open": isOpen,
            onClick: closeOnClick(setIsOpen),
        },
    };
};

export { useLayoutSidebar };
//# sourceMappingURL=useLayoutSidebar.js.map
